import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';

const routeNameMap = {
  '/login': 'Login',
  '/lifeline': 'Lifeline Dashboard',
  '/lifeline/smartplugs/o2-india-lifeline': 'Smartplug Dashboard',
  '/lifeline/smartplugs/delivery-partner': 'Delivery Partner Smartplug',
  '/lifeline/smartplugs/handover': 'Handover Dashboard',
  '/permissions-dashboard': 'Permissions Dashboard',
  '/admin-dashboard': 'Admin Dashboard',
  '/bulk-uploads': 'Bulk Uploads',
};

function getViewName(pathname) {
  if (routeNameMap[pathname]) return routeNameMap[pathname];
  for (const [route, name] of Object.entries(routeNameMap)) {
    if (pathname.startsWith(route)) return name;
  }
  return pathname.replace(/\/\d+/g, '/:id');
}

export default function DatadogViewTracker() {
  const location = useLocation();
  const previousPath = useRef(null);

  useEffect(() => {
    if (location.pathname !== previousPath.current) {
      previousPath.current = location.pathname;
      if (datadogRum.getInitConfiguration()) {
        datadogRum.startView({ name: getViewName(location.pathname) });
      }
    }
  }, [location]);

  return null;
}
